import React, { useState } from 'react';
import {
  Box,
  Button,
  TextField
} from '@mui/material';
import { TrendingUp as TrendingUpIcon } from '@mui/icons-material';
import { useGlobal } from '../contexts/GlobalContext';

const BoostWalletTagsSection = ({ onUpdate, lookupIndex = 'polymarket-wallets' }) => {
  const boostInput = true;
  const { defaultPolymarketWalletAddress, defaultKalshiWalletAddress } = useGlobal();
  const initialWallet = lookupIndex === 'kalshi-wallets'
    ? defaultKalshiWalletAddress
    : defaultPolymarketWalletAddress;
  const [currentWalletAddress, setCurrentWalletAddress] = useState(initialWallet || '');
  const [minBoost, setMinBoost] = useState(1);
  const [maxBoost, setMaxBoost] = useState(5);

  const handleWalletPreferenceAction = (actionType) => {
    if (!currentWalletAddress.trim()) return;
    
    const updateData = {
      action: actionType,
      filter: 'group_boost',
      field: 'tags',
      lookup_index: lookupIndex,
      value: currentWalletAddress.trim(),
      group: 'tag',
      n: 10,
    };
    
    // Add boost values if boostInput is enabled
    if (boostInput) {
      updateData.min_boost = minBoost;
      updateData.max_boost = maxBoost;
    }
    
    onUpdate(updateData);
  };

  return (
    <Box>
      <TextField
        label="Wallet Address"
        value={currentWalletAddress}
        onChange={(e) => setCurrentWalletAddress(e.target.value)}
        placeholder="Enter wallet address"
        helperText="e.g., 0x1234...abcd"
        fullWidth
        sx={{ mb: 2 }}
      />
      
      {boostInput && (
        <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
          <TextField
            fullWidth
            label="Min Boost"
            type="number"
            value={minBoost}
            onChange={(e) => setMinBoost(parseFloat(e.target.value) || 0)}
            inputProps={{ min: 0, step: 0.1 }}
          />
          <TextField
            fullWidth
            label="Max Boost"
            type="number"
            value={maxBoost}
            onChange={(e) => setMaxBoost(parseFloat(e.target.value) || 1)}
            inputProps={{ min: 0, step: 0.1 }}
          />
        </Box>
      )}
      
      <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end' }}>
        
        {boostInput && (
          <Button
            variant="contained"
            color="success"
            onClick={() => handleWalletPreferenceAction('boost')}
            disabled={!currentWalletAddress.trim()}
          >
            <TrendingUpIcon />
          </Button>
        )}
        
      </Box>
    </Box>
  );
};

export default BoostWalletTagsSection;
